import axios from 'axios'
import qs from 'qs'
import constants from '@/helpers/constants'
const MAX_VISIBLE_QUESTIONS = constants.IS_CHECKOUT_SUCCESS() ? 5 : Infinity

export default {
  namespaced: true,
  state: {
    polls: null,
    results: null,
    sendInfo: null,
    submittedStatus: null,
    showTrimmedPoll: null,
    loadingData: false,
    isFormSubmitted: false,
    requestId: '',
    errorFromServer: '',
    temporaryPolls: {},
    questionTypes: {
      EMAIL_MASK: 'E-mail',
      LINK_MASK: 'Link',
      PHONE_MASK: 'Phone',
      TEXT_MASK: 'Text',
      CITY_MASK: 'UID City',
      TEXTAREA_TYPE: 'textarea',
      RADIO_TYPE: 'radio',
      RADIO_RATE_TYPE: 'radio_rate',
      DATE_TYPE: 'date',
      NUMBER_TYPE: 'number',
      CHECKBOX_TYPE: 'checkbox',
      TELEGRAM_LINK_TYPE: 'telegram',
      VIBER_LINK_TYPE: 'viber',
      INSTAGRAM_LINK_TYPE: 'instagram',
      FACEBOOK_LINK_TYPE: 'facebook',
      TIKTOK_LINK_TYPE: 'tiktok',
      YOUTUBE_LINK_TYPE: 'youtube',
      DEFAULT_LINK_TYPE: 'default'
    }
  },
  getters: {
    questionnaireErrors: (state) => {
      const errors = {}

      for (let poll in state.polls) {
        if (!poll) return

        if (state.polls.hasOwnProperty(poll)) {
          errors[poll] = []

          Object.values(state.polls[poll].pollQuestions).forEach(question => {
            if (question.required === '1' && !state.results[poll].answers[question.uid].answer.length) {
              errors[poll].push(question.uid)
            }
          })
        }
      }

      return errors
    },
    pollQuestionsForDisplaying: (state) => (pollUid) => {
      const conditions = {
        isQuestionHasAnswer: (questionId) => state.results[pollUid].answers[questionId].answer.length > 0,
        isRequired: (questionId) => state.polls[pollUid].pollQuestions[questionId].required === '1',
        isLinkType: (questionId) => state.polls[pollUid].pollQuestions[questionId].mask === state.questionTypes.LINK_MASK,
        isRenderQuestion: (uid, poll) => !(poll.parent_answer_uid && poll.parent_question_uid) ||
            state.results[uid]?.answers[poll.parent_question_uid]?.answer?.includes(poll.parent_answer_uid) ||
            (poll.mask === state.questionTypes.LINK_MASK && state.results[uid]?.answers[poll.parent_question_uid]?.answer?.length)

      }

      if (!state.showTrimmedPoll[pollUid]) {
        return Object.keys(state.polls[pollUid].pollQuestions)
          .filter(questionUid => conditions.isRenderQuestion(pollUid, state.polls[pollUid].pollQuestions[questionUid]))
          .reduce((obj, key) => {
            obj[key] = state.polls[pollUid].pollQuestions[key]
            return obj
          }, {})
      }

      const questionsIds = Object.keys(state.polls[pollUid].pollQuestions)

      const requiredQuestionsWithoutAnswers = []
      const notRequiredQuestionsWithoutAnswers = []

      for (let i = 0; i < questionsIds.length; i++) {
        const isQuestionRequired = conditions.isRequired(questionsIds[i])
        const isQuestionHasAnswer = conditions.isQuestionHasAnswer(questionsIds[i])
        const isLinkQuestion = conditions.isLinkType(questionsIds[i])

        if (!isQuestionHasAnswer) {
          if (isQuestionRequired) {
            requiredQuestionsWithoutAnswers.push(questionsIds[i])
          } else if (conditions.isRenderQuestion(pollUid, state.polls[pollUid].pollQuestions[questionsIds[i]]) && !isLinkQuestion) {
            notRequiredQuestionsWithoutAnswers.push(questionsIds[i])
          }
        }
      }

      const result = requiredQuestionsWithoutAnswers.length < MAX_VISIBLE_QUESTIONS
        ? requiredQuestionsWithoutAnswers.concat(notRequiredQuestionsWithoutAnswers).slice(0, MAX_VISIBLE_QUESTIONS)
        : requiredQuestionsWithoutAnswers

      return result.reduce((obj, key, ii, arr) => {
        obj[key] = state.polls[pollUid].pollQuestions[key]
        return obj
      }, {})
    },
    computedPolls: (state, getters) => {
      return getters.pollsIds.reduce((acc, item) => {
        // если стоит условие показывать обрезанный опросник (state.showTrimmedPoll[item]), то выводим опросник, который
        // при изменении ответа, не будет перерендериваться
        // , (т.е. не будет рендерить дочерние вопросы и скрывать уже отвеченные).
        acc[item] = state.showTrimmedPoll[item] ? state.temporaryPolls[item] : getters.pollQuestionsForDisplaying(item)
        return acc
      }, {})
    },
    pollsIds: (state) => {
      return Object.keys(state.polls || {})
    },
    isPollsVisible: (state, getters) => {
      if (state.loadingData) return true
      return getters.pollsIds.some((pollId) => Object.keys(getters.computedPolls[pollId]).length > 0)
    }
  },
  mutations: {
    SET_DATA: (state, data) => {
      if (!data) return

      if (data && data.length) {
        let result = {
          polls: {},
          results: {},
          sendInfo: {},
          submittedStatus: {},
          showTrimmedPoll: {}
        }

        result = data.reduce((acc, item) => {
          let questions = {}
          let answers = {}

          if (!item) return

          item.poll.pollQuestions = item.poll.pollQuestions.sort((a, b) => {
            return Number(a.sort) - Number(b.sort)
          })

          questions = item.poll.pollQuestions.reduce((acc, question) => {
            acc[question.uid] = question

            answers[question.uid] = {
              answer: [],
              question_uid: question.uid
            }

            return acc
          }, questions)

          if (item.results?.answers.length) {
            answers = item.results.answers.reduce((acc, answer) => {
              if (acc[answer.question_uid]) {
                acc[answer.question_uid] = answer
              }

              return acc
            }, answers)
          }

          acc.polls[item.poll.uid] = { ...item.poll, pollQuestions: questions }

          acc.results[item.poll.uid] = {
            answers: answers,
            survey_uid: item.poll.uid,
            poll_id: item.poll_id,
            user_id: item.user_id,
            customer_uid: item.customer_uid,
            document_uid: item.document_uid
          }

          acc.sendInfo[item.poll.uid] = {}
          acc.submittedStatus[item.poll.uid] = false
          acc.showTrimmedPoll[item.poll.uid] = constants.IS_CHECKOUT_SUCCESS()
          return acc
        }, result)
        state.polls = result.polls
        state.results = result.results
        state.sendInfo = result.sendInfo
        state.submittedStatus = result.submittedStatus
        state.showTrimmedPoll = result.showTrimmedPoll
      }
    },
    SET_ANSWER: (state, data) => {
      const { uid, answerUid, answer, type } = data
      let stateAnswer = state.results[uid].answers[answerUid].answer
      const answerIndex = stateAnswer.indexOf(answer)

      switch (type) {
        case 'reset':
        case 'textarea':
        case 'radio':
        case 'radio_rate':
          stateAnswer = answer
          break
        case 'date':
          stateAnswer = answer ? [answer] : []
          break
        case 'checkbox':
          answerIndex !== -1 ? stateAnswer.splice(answerIndex, 1) : stateAnswer.push(answer)
          break
      }

      state.results[uid].answers[answerUid].answer = stateAnswer
    },
    SET_SUBMITTED_STATUS: (state, data) => {
      state.submittedStatus[data.pollUid] = data.status
    },
    SET_SEND_INFO: (state, data) => {
      state.sendInfo[data.uid] = data.info
    },
    SET_REQUEST_ID: (state, id) => {
      state.requestId = id
    },
    SET_LOADING_DATA: (state, bool) => {
      state.loadingData = bool
    },
    CHANGE_SHOW_TRIMMED_POLL: (state, data) => {
      state.showTrimmedPoll[data.uid] = data.status
    },
    SET_TEMPORARY_POLLS: (state, data) => {
      state.temporaryPolls = data
    }
  },
  actions: {
    GET_CITIES: ({ commit, rootGetters }, data) => {
      const params = {}

      if (data.city) params.city = data.city
      if (data.city_uid) params.city_uid = data.city_uid

      return new Promise((resolve, reject) => {
        axios
          .get(rootGetters.urlLanguagePrefix + '/shop/checkout/get-cities/', { params })
          .then(res => {
            resolve(res.data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    GET_QUESTIONS: ({ commit, rootGetters, state, getters }, data) => {
      commit('SET_LOADING_DATA', true)
      const params = {}

      if (data.pollId) params.id = data.pollId
      if (data.storeUid) params.store_uid = data.storeUid

      return new Promise((resolve, reject) => {
        axios
          .get(rootGetters.urlLanguagePrefix + data.endpoint, { params })
          .then(res => {
            commit('SET_DATA', res.data.poll_data)
            const temporaryPolls = getters.pollsIds.reduce((acc, item) => {
              acc[item] = getters.pollQuestionsForDisplaying(item)
              return acc
            }, {})
            commit('SET_TEMPORARY_POLLS', temporaryPolls)
            resolve(res.data)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_LOADING_DATA', false)
          })
      })
    },
    SEND_RESULTS: ({ state, commit, rootGetters, getters, dispatch }, data) => {
      commit('SET_SUBMITTED_STATUS', { pollUid: data.pollUid, status: true })

      const params = {
        ...state.results[data.pollUid],
        answers: Object.values(state.results[data.pollUid].answers).filter(answer => answer.answer.length)
      }

      data.part ? params.part = 1 : params.part = 0

      return new Promise((resolve, reject) => {
        if (!getters.questionnaireErrors[data.pollUid].length) {
          axios
            .post(rootGetters.urlLanguagePrefix + data.endpoint, qs.stringify(params))
            .then(res => {
              commit('SET_SUBMITTED_STATUS', { pollUid: data.pollUid, status: false })
              commit('SET_SEND_INFO', { info: res.data, uid: data.pollUid })

              resolve(res)
            })
            .catch(() => {
              reject(rootGetters.translations('error_occurred'))
            })
        } else {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject(rootGetters.translations('error_occurred'))
        }
      })
    },
    SET_ANSWER_ACTION: ({ commit }, data) => {
      commit('SET_ANSWER', data)
    },
    SET_REQUEST_ID_ACTION: ({ commit }, id) => {
      commit('SET_REQUEST_ID', id)
    },
    CHANGE_SHOW_TRIMMED_POLL_ACTION: ({ commit }, data) => {
      commit('CHANGE_SHOW_TRIMMED_POLL', data)
    }
  }
}
